import { render, staticRenderFns } from "./channel-dependency-manage-modal.vue?vue&type=template&id=2100b2b2"
import script from "./channel-dependency-manage-modal.vue?vue&type=script&lang=js"
export * from "./channel-dependency-manage-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports